import React from 'react';
import Navbar from '../../components/Navbar';
import SegmAnnoLabelDetail from '../../components/SegmAnnoLabel/SegmAnnoLabelDetail';
import './SegmAnnoLabelDetailPage.css';

const SegmAnnoLabelDetailPage = () => {
  return (
    <div className="segm-anno-label-detail-page">
      <Navbar />
      <div className="segm-anno-label-detail-content">
        <SegmAnnoLabelDetail />
      </div>
    </div>
  );
};

export default SegmAnnoLabelDetailPage;
